import { createClient } from '@supabase/supabase-js';

// Supabase anon key는 RLS로 보호되는 공개 키 — 클라이언트 번들에 포함되어도 안전
const SUPABASE_URL =
  (import.meta as any).env?.PUBLIC_SUPABASE_URL ||
  'https://iiefijccyioycwlgaufo.supabase.co';
const SUPABASE_ANON_KEY =
  (import.meta as any).env?.PUBLIC_SUPABASE_ANON_KEY ||
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImlpZWZpamNjeWlveWN3bGdhdWZvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjY5MDg3NjYsImV4cCI6MjA4MjQ4NDc2Nn0.V_PE-PkSwcB9ZstTE0n5WGco45JrLJtcjC6LHZ3h2ck';

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  console.error('Supabase 환경변수가 설정되지 않았습니다 (PUBLIC_SUPABASE_URL, PUBLIC_SUPABASE_ANON_KEY).');
}

/**
 * Realtime broadcast 전용 클라이언트.
 * - DB 직접 접근은 백엔드 API를 통해 수행 (자체 HMAC 세션과 통합)
 * - Realtime broadcast/presence는 RLS 무관하므로 anon key로 채널 구독 가능
 */
export const supabaseClient = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: false,
    autoRefreshToken: false,
    detectSessionInUrl: false,
  },
  realtime: {
    params: { eventsPerSecond: 10 },
  },
});
